"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  LibraryMusic1: ['library-music-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.75,16.5v5.25a1.5,1.5,0,0,1-1.5,1.5h-12a1.5,1.5,0,0,1-1.5-1.5V5.251a1.5,1.5,0,0,1,1.5-1.5h7.5', 'M0.75 13.501L9.75 13.501', 'M0.75 7.501H3.75V13.501000000000001H0.75z', 'M3.75,7.5H6.243a.5.5,0,0,1,.5.5v5.5a0,0,0,0,1,0,0H3.75a0,0,0,0,1,0,0v-6A0,0,0,0,1,3.75,7.5Z', 'M.75,17.251h2.5a.5.5,0,0,1,.5.5v5.5', 'M7.25,17.251h2a.5.5,0,0,1,.5.5v5.5a0,0,0,0,1,0,0h-3a0,0,0,0,1,0,0v-5.5A.5.5,0,0,1,7.25,17.251Z', 'M3.75 18.001H6.75V23.251H3.75z', 'M12.000 10.295 A1.875 1.875 0 1 0 15.750 10.295 A1.875 1.875 0 1 0 12.000 10.295 Z', 'M19.500 8.045 A1.875 1.875 0 1 0 23.250 8.045 A1.875 1.875 0 1 0 19.500 8.045 Z', 'M15.75,10.3V3.5a1.5,1.5,0,0,1,1.026-1.423l4.5-1.25A1.5,1.5,0,0,1,23.25,2.251V8.045']],
  ReadHome2: ['read-home-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21,23.251H5.25A2.25,2.25,0,0,1,3,21H3a2.25,2.25,0,0,1,2.25-2.25H19.5a1.5,1.5,0,0,0,1.5-1.5v-15a1.5,1.5,0,0,0-1.5-1.5H4.957A1.957,1.957,0,0,0,3,2.708V21', 'M19.5 18.751L19.5 23.251', 'M15 8.751L15 14.251 9 14.251 9 8.751', 'M7.5 9.751L12 6.751 16.5 9.751']],
  LibraryArt: ['library-art', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.457,1.293A6.16,6.16,0,0,0,15.905.751c-2.985,0-5.4,2.049-5.4,4.576A4.633,4.633,0,0,0,13.8,9.54c.767.274,1.4.051,1.845-.966a1.6,1.6,0,0,1,1.584-1.018', 'M20.976 6.168L18.157 11.897', 'M20.372,4.326a1.383,1.383,0,0,0,.6,1.842,1.342,1.342,0,0,0,1.813-.614,2.959,2.959,0,0,0-.6-3.888C22.386,3.3,21.178,2.689,20.372,4.326Z', 'M13.875,5.159a.378.378,0,0,1,.375.381', 'M13.5,5.54a.378.378,0,0,1,.375-.381', 'M13.875,5.921A.378.378,0,0,1,13.5,5.54', 'M14.25,5.54a.378.378,0,0,1-.375.381', 'M16.125,2.909a.378.378,0,0,1,.375.381', 'M15.75,3.29a.378.378,0,0,1,.375-.381', 'M16.125,3.671a.378.378,0,0,1-.375-.381', 'M16.5,3.29a.378.378,0,0,1-.375.381', 'M15.75,16.5v5.25a1.5,1.5,0,0,1-1.5,1.5h-12a1.5,1.5,0,0,1-1.5-1.5V5.251a1.5,1.5,0,0,1,1.5-1.5H7.5', 'M0.75 13.501L14.25 13.501', 'M0.75 7.501H3.75V13.501000000000001H0.75z', 'M3.75,7.5H6.243a.5.5,0,0,1,.5.5v5.5a0,0,0,0,1,0,0H3.75a0,0,0,0,1,0,0v-6A0,0,0,0,1,3.75,7.5Z', 'M.75,17.251h2.5a.5.5,0,0,1,.5.5v5.5', 'M7.25,17.251h2a.5.5,0,0,1,.5.5v5.5a0,0,0,0,1,0,0h-3a0,0,0,0,1,0,0v-5.5A.5.5,0,0,1,7.25,17.251Z', 'M3.75 18.001H6.75V23.251H3.75z']],
  Library: ['library', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 0.751 L21.750 0.751 L21.750 23.251 L2.250 23.251 Z', 'M2.25 11.251L21.75 11.251', 'M7.25,15.751h2.5a0,0,0,0,1,0,0v7.5a0,0,0,0,1,0,0h-2a1,1,0,0,1-1-1v-6A.5.5,0,0,1,7.25,15.751Z', 'M2.25 4.501H5.25V11.251000000000001H2.25z', 'M5.25 3.751H8.25V11.251H5.25z', 'M8.25,3.751h2.5a.5.5,0,0,1,.5.5v7a0,0,0,0,1,0,0h-3a0,0,0,0,1,0,0v-7.5A0,0,0,0,1,8.25,3.751Z', 'M16.3,10.516l-2.047.735-2.211-6.2A.754.754,0,0,1,12.5,4.09l1.341-.482a.75.75,0,0,1,.959.455l1.958,5.491A.754.754,0,0,1,16.3,10.516Z', 'M18.75 23.251L18.75 15.751 21.75 15.751', 'M15.75 15.751H18.75V23.250999999999998H15.75z', 'M10.25,14.251h2.5a0,0,0,0,1,0,0v9a0,0,0,0,1,0,0h-3a0,0,0,0,1,0,0v-8.5A.5.5,0,0,1,10.25,14.251Z', 'M12.75,14.251h2.5a.5.5,0,0,1,.5.5v8.5a0,0,0,0,1,0,0h-3a0,0,0,0,1,0,0v-9A0,0,0,0,1,12.75,14.251Z']],
  LibraryHidden: ['library-hidden', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-2.213 2.656) rotate(-13.535)'
  }], ['M12.844,4.436a.558.558,0,0,1,0-.619A6.52,6.52,0,0,1,18,.751a6.52,6.52,0,0,1,5.156,3.066.558.558,0,0,1,0,.619A6.522,6.522,0,0,1,18,7.5,6.522,6.522,0,0,1,12.844,4.436Z', 'M20.485 1.371L15.524 6.89', 'M15.75,10.5v11.25a1.5,1.5,0,0,1-1.5,1.5h-12a1.5,1.5,0,0,1-1.5-1.5V5.251a1.5,1.5,0,0,1,1.5-1.5h7.5', 'M0.75 13.501L15.75 13.501', 'M0.75 7.501H3.75V13.501000000000001H0.75z', 'M3.75,7.5H6.243a.5.5,0,0,1,.5.5v5.5a0,0,0,0,1,0,0H3.75a0,0,0,0,1,0,0v-6A0,0,0,0,1,3.75,7.5Z', 'M.75,17.251h2.5a.5.5,0,0,1,.5.5v5.5', 'M7.25,17.251h2a.5.5,0,0,1,.5.5v5.5a0,0,0,0,1,0,0h-3a0,0,0,0,1,0,0v-5.5A.5.5,0,0,1,7.25,17.251Z', 'M3.75 18.001H6.75V23.251H3.75z', 'M8.703 7.891 L11.462 7.891 L11.462 13.410 L8.703 13.410 Z']],
  ReadGlasses1: ['read-glasses-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,23.251l-8.778-3.34a1.405,1.405,0,0,1-.972-1.337V11.251A1.406,1.406,0,0,1,4.091,9.914L12,12.972Z', 'M20.778,19.911,12,23.251V12.972l7.909-3.058a1.406,1.406,0,0,1,1.841,1.337v7.323A1.405,1.405,0,0,1,20.778,19.911Z', 'M3.000 4.501 A3.750 3.750 0 1 0 10.500 4.501 A3.750 3.750 0 1 0 3.000 4.501 Z', 'M13.500 4.501 A3.750 3.750 0 1 0 21.000 4.501 A3.750 3.750 0 1 0 13.500 4.501 Z', 'M10.5,4.572a1.5,1.5,0,1,1,3,0', 'M23.25 4.501L21 4.501', 'M3 4.501L0.75 4.501', 'M15.75 15.751L18 15.001']],
  ReadArt: ['read-art', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.957,5.043A6.16,6.16,0,0,0,11.405,4.5C8.42,4.5,6,6.55,6,9.077A4.633,4.633,0,0,0,9.3,13.29c.767.274,1.4.051,1.845-.966a1.6,1.6,0,0,1,1.584-1.018', 'M16.476 9.918L13.657 15.647', 'M15.872,8.076a1.383,1.383,0,0,0,.6,1.842A1.342,1.342,0,0,0,18.289,9.3a2.959,2.959,0,0,0-.6-3.888C17.886,7.053,16.678,6.439,15.872,8.076Z', 'M9.375,8.909a.378.378,0,0,1,.375.381', 'M9,9.29a.378.378,0,0,1,.375-.381', 'M9.375,9.671A.378.378,0,0,1,9,9.29', 'M9.75,9.29a.378.378,0,0,1-.375.381', 'M11.625,6.659A.378.378,0,0,1,12,7.04', 'M11.25,7.04a.378.378,0,0,1,.375-.381', 'M11.625,7.421a.378.378,0,0,1-.375-.381', 'M12,7.04a.378.378,0,0,1-.375.381', 'M21,23.251H5.25A2.25,2.25,0,0,1,3,21H3a2.25,2.25,0,0,1,2.25-2.25H19.5a1.5,1.5,0,0,0,1.5-1.5v-15a1.5,1.5,0,0,0-1.5-1.5H4.957A1.957,1.957,0,0,0,3,2.708V21.3', 'M19.5 18.751L19.5 23.251']],
  ReadHome: ['read-home', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,23.251s2.043-2.533,7.768-2.669a.491.491,0,0,0,.482-.489V10.241a.492.492,0,0,0-.507-.489c-5.7.142-7.743,3-7.743,3s-2.038-2.857-7.743-3a.493.493,0,0,0-.507.489v9.852a.491.491,0,0,0,.482.489C9.957,20.718,12,23.251,12,23.251Z', 'M12 12.751L12 23.251', 'M0.75 7.599L12 0.751 23.25 7.501', 'M18.75 0.751L21 0.751 21 3.001']],
  ReadLightIdea: ['read-light-idea', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,23.251c-.528-1.663-3.943-3.6-9.843-3.866A1.5,1.5,0,0,1,.75,17.878V4.527a1.5,1.5,0,0,1,1.607-1.5c3.865.2,6.608,1.125,8.157,2.205', 'M12,23.251c.528-1.663,3.943-3.6,9.843-3.866a1.5,1.5,0,0,0,1.407-1.507V9', 'M9.342,8.773a24.438,24.438,0,0,0-5.574-1.3', 'M9.342,12.588a25.017,25.017,0,0,0-5.574-1.3', 'M9.342,16.632a25.247,25.247,0,0,0-5.625-1.3', 'M12 10.501L12 23.251', 'M17.25 0.751L17.25 2.251', 'M12.439 3.221L13.5 4.282', 'M22.061 3.221L21 4.282', 'M17.25 12.751L17.25 14.251', 'M20.25,8.251a3,3,0,1,0-4.5,2.584v1.916h3V10.835A2.986,2.986,0,0,0,20.25,8.251Z']],
  ReadMusic: ['read-music', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.250 13.126 A1.875 1.875 0 1 0 12.000 13.126 A1.875 1.875 0 1 0 8.250 13.126 Z', 'M12,13.126V5.661a.476.476,0,0,1,.75-.327l3,1.963', 'M21,23.251H5.25A2.25,2.25,0,0,1,3,21H3a2.25,2.25,0,0,1,2.25-2.25H19.5a1.5,1.5,0,0,0,1.5-1.5v-15a1.5,1.5,0,0,0-1.5-1.5H4.957A1.957,1.957,0,0,0,3,2.708V21.3', 'M19.5 18.751L19.5 23.251']],
  ReadWorld: ['read-world', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.750 11.251 L23.250 11.251 L23.250 23.251 L12.750 23.251 Z', 'M18 14.251L20.25 14.251', 'M15.75 17.251L20.25 17.251', 'M15.75 20.251L20.25 20.251', 'M9.754,20.223A9.75,9.75,0,1,1,19.99,8.255', 'M6.75,19.5V15s1.009-.46,1.27-1.048a1.3,1.3,0,0,0-.04-1.139L6.721,10.448A1.3,1.3,0,0,0,5.259,9.8l-4.5,1.122', 'M5.25,2.284V6.236A1.3,1.3,0,0,0,6.235,7.5l1.9.65A1.3,1.3,0,0,0,9.75,6.886V5.518l4.164-.686A1.3,1.3,0,0,0,15,3.55V1.85']],
  ReadGlasses: ['read-glasses', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.75 15.751L21.75 15.751', 'M3.75 18.751L21.75 18.751', 'M3.000 6.001 A3.750 3.750 0 1 0 10.500 6.001 A3.750 3.750 0 1 0 3.000 6.001 Z', 'M13.500 6.001 A3.750 3.750 0 1 0 21.000 6.001 A3.750 3.750 0 1 0 13.500 6.001 Z', 'M10.5,6.072a1.5,1.5,0,1,1,3,0', 'M23.25 6.001L21 6.001', 'M3 6.001L0.75 6.001', 'M23.25,21.751H3.75a3,3,0,0,1-3-3v-3a3,3,0,0,1,3-3h19.5']],
  ReadHuman: ['read-human', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5,19.251v1a.905.905,0,0,0,.589.887L12.5,23.251V14.418L6.027,12.045A.817.817,0,0,0,5,12.919v1.844', 'M20.013,19.1v1.157a.9.9,0,0,1-.588.887L12.5,23.251V14.418l6.486-2.373a.817.817,0,0,1,1.027.874v1.988', 'M6.487,18.358c0,.5-.563.9-1.251.893-1.378-.006-2.491-.816-2.486-1.81l0-.9c0-.993,1.125-1.793,2.5-1.787.689,0,1.245.408,1.243.9Z', 'M17.757,18.358c0,.5.563.9,1.253.893,1.38-.006,2.495-.816,2.49-1.81l0-.9c0-.993-1.127-1.793-2.507-1.787-.689,0-1.247.408-1.244.9Z', 'M8.387 4.876 A4.125 4.125 0 1 0 16.637 4.876 A4.125 4.125 0 1 0 8.387 4.876 Z']],
  LibraryMusic: ['library-music', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-2.213 2.656) rotate(-13.535)'
  }], ['M16.156.751A5.251,5.251,0,1,0,23.25,5.669', 'M16.500 6.419 A1.500 1.500 0 1 0 19.500 6.419 A1.500 1.500 0 1 0 16.500 6.419 Z', 'M19.5 6.419L19.5 1.169 21.75 2.669', 'M15.75,13.5v8.25a1.5,1.5,0,0,1-1.5,1.5h-12a1.5,1.5,0,0,1-1.5-1.5V5.251a1.5,1.5,0,0,1,1.5-1.5h7.5', 'M0.75 13.501L15.75 13.501', 'M0.75 7.501H3.75V13.501000000000001H0.75z', 'M3.75,7.5H6.243a.5.5,0,0,1,.5.5v5.5a0,0,0,0,1,0,0H3.75a0,0,0,0,1,0,0v-6A0,0,0,0,1,3.75,7.5Z', 'M.75,17.251h2.5a.5.5,0,0,1,.5.5v5.5', 'M7.25,17.251h2a.5.5,0,0,1,.5.5v5.5a0,0,0,0,1,0,0h-3a0,0,0,0,1,0,0v-5.5A.5.5,0,0,1,7.25,17.251Z', 'M3.75 18.001H6.75V23.251H3.75z', 'M8.703 7.891 L11.462 7.891 L11.462 13.410 L8.703 13.410 Z']],
  LibrarySports: ['library-sports', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-2.215 2.656) rotate(-13.535)'
  }], ['M17.947,4.479l.267-1.76a2.132,2.132,0,0,1,3.077,0,2.132,2.132,0,0,1,0,3.078l-1.576.45', 'M21.291,5.8s1.539-.769,1.924,1.154c.261,1.306-.326,1.2-5.5,2.659', 'M18.214,2.719S18.983,1.181,17.06.8c-1.42-.284-1.335.7-2.531,5.632', 'M17.711,9.61l-.53.531a2.257,2.257,0,0,1-3.182,0h0a2.257,2.257,0,0,1,0-3.182l.53-.531Z', 'M15.75,13.511v8.25a1.5,1.5,0,0,1-1.5,1.5h-12a1.5,1.5,0,0,1-1.5-1.5V5.261a1.5,1.5,0,0,1,1.5-1.5h7.5', 'M0.75 13.511L15.75 13.511', 'M0.75 7.511H3.75V13.511H0.75z', 'M3.75,7.511H6.243a.5.5,0,0,1,.5.5v5.5a0,0,0,0,1,0,0H3.75a0,0,0,0,1,0,0v-6A0,0,0,0,1,3.75,7.511Z', 'M.75,17.261h2.5a.5.5,0,0,1,.5.5v5.5', 'M7.25,17.261h2a.5.5,0,0,1,.5.5v5.5a0,0,0,0,1,0,0h-3a0,0,0,0,1,0,0v-5.5A.5.5,0,0,1,7.25,17.261Z', 'M3.75 18.011H6.75V23.261H3.75z', 'M8.703 7.900 L11.462 7.900 L11.462 13.419 L8.703 13.419 Z']],
  ReadHome1: ['read-home-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.817,19.669a19.96,19.96,0,0,0-6.66-1.307A1.5,1.5,0,0,1,.75,16.855V3.5A1.5,1.5,0,0,1,2.357,2C8.876,2.345,12,4.979,12,6.478', 'M23.25,11.728V3.5A1.5,1.5,0,0,0,21.643,2C15.124,2.345,12,4.979,12,6.478', 'M12 6.478L12.01 11.729', 'M12.75,14.926v5.8a1.5,1.5,0,0,0,1.5,1.5h6a1.5,1.5,0,0,0,1.5-1.5v-5.8', 'M11.25,16.238l4.518-3.953a2.252,2.252,0,0,1,2.964,0l4.518,3.953', 'M18.75,22.228h-3v-3a1.5,1.5,0,0,1,3,0Z']],
  ReadMusicInstrument: ['read-music-instrument', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.041,12.1l.265-2.038c.265-2.038.181-5.157,2.654-5.354,2-.159,2.142,2.351,2.142,2.351.282,1.591,1.311,1.207,1.311,1.207', 'M14.266,9.752c-.013,4.154-1.647,6.177-3.689,5.912a3.12,3.12,0,0,1-3.038-2.985A4.143,4.143,0,0,0,6.88,11.02a.521.521,0,0,1,.283-.79l4.252-1.182', 'M21,23.251H5.25A2.25,2.25,0,0,1,3,21H3a2.25,2.25,0,0,1,2.25-2.25H19.5a1.5,1.5,0,0,0,1.5-1.5v-15a1.5,1.5,0,0,0-1.5-1.5H4.957A1.957,1.957,0,0,0,3,2.708V21.3', 'M19.5 18.751L19.5 23.251']],
  ReadSearch: ['read-search', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.75,9.752V2.259A1.5,1.5,0,0,0,20.037.768a15.934,15.934,0,0,0-7.851,3.574,1.525,1.525,0,0,1-1.872,0A15.93,15.93,0,0,0,2.463.768,1.5,1.5,0,0,0,.75,2.259v13.6a1.492,1.492,0,0,0,1.3,1.481,14.64,14.64,0,0,1,5.44,1.741', 'M11.25 4.663L11.25 7.501', 'M8.254,7.23A14.875,14.875,0,0,0,4.542,5.548', 'M8.254,10.975A10.342,10.342,0,0,0,3.738,9.084', 'M14.246,7.23a14.875,14.875,0,0,1,3.712-1.682', 'M9.750 15.751 A6.000 6.000 0 1 0 21.750 15.751 A6.000 6.000 0 1 0 9.750 15.751 Z', 'M23.25 23.251L19.993 19.994', 'M15.75 17.251L15.75 14.251', 'M14.25 14.251L17.25 14.251']],
  ReadSports: ['read-sports', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.1,8.22l.267-1.76a2.176,2.176,0,0,1,3.078,3.078l-1.577.449', 'M15.449,9.538s1.539-.77,1.923,1.154c.261,1.3-.325,1.2-5.5,2.659', 'M12.371,6.46s.77-1.539-1.154-1.923c-1.419-.284-1.334.7-2.53,5.632', 'M11.869,13.351l-.531.53a2.257,2.257,0,0,1-3.182,0h0a2.257,2.257,0,0,1,0-3.182l.531-.53Z', 'M21,23.251H5.25A2.25,2.25,0,0,1,3,21H3a2.25,2.25,0,0,1,2.25-2.25H19.5a1.5,1.5,0,0,0,1.5-1.5v-15a1.5,1.5,0,0,0-1.5-1.5H4.957A1.957,1.957,0,0,0,3,2.708V21', 'M19.5 18.751L19.5 23.251']],
  LibraryMaths: ['library-maths', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-2.089 2.7) rotate(-13.535)'
  }], ['M22.75 8.501L17.5 8.501', 'M20.125,5.5a.375.375,0,0,0-.375.375', 'M20.5,5.876a.375.375,0,0,0-.375-.375', 'M20.125,6.251a.374.374,0,0,0,.375-.375', 'M19.75,5.876a.374.374,0,0,0,.375.375', 'M20.125,10.751a.375.375,0,0,0-.375.375', 'M20.5,11.126a.375.375,0,0,0-.375-.375', 'M20.125,11.5a.374.374,0,0,0,.375-.375', 'M19.75,11.126a.374.374,0,0,0,.375.375', 'M13 3.251L14.5 5.501 16 1.001 21.25 1.001', 'M16,16v5.25a1.5,1.5,0,0,1-1.5,1.5H2.5a1.5,1.5,0,0,1-1.5-1.5V4.751a1.5,1.5,0,0,1,1.5-1.5H10', 'M1 13.001L14.5 13.001', 'M1 7.001H4V13.001000000000001H1z', 'M4,7H6.493a.5.5,0,0,1,.5.5V13a0,0,0,0,1,0,0H4a0,0,0,0,1,0,0V7A0,0,0,0,1,4,7Z', 'M1,16.751H3.5a.5.5,0,0,1,.5.5v5.5', 'M7.5,16.751h2a.5.5,0,0,1,.5.5v5.5a0,0,0,0,1,0,0H7a0,0,0,0,1,0,0v-5.5A.5.5,0,0,1,7.5,16.751Z', 'M4 17.501H7V22.751H4z', 'M8.953 7.391 L11.712 7.391 L11.712 12.910 L8.953 12.910 Z']],
  ReadMaths: ['read-maths', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,23.251c-.507-1.667-3.918-3.617-9.843-3.886A1.5,1.5,0,0,1,.75,17.858V4.507a1.482,1.482,0,0,1,.83-1.344', 'M12,23.251c.507-1.667,3.918-3.617,9.843-3.886a1.5,1.5,0,0,0,1.407-1.507V4.507a1.482,1.482,0,0,0-.83-1.344', 'M12 14.251L12 23.251', 'M17.25 1.501L17.25 6.001', 'M15 3.751L19.5 3.751', 'M7.5 7.501L12.75 7.501', 'M10.125,4.5a.375.375,0,0,1,.375.375', 'M9.75,4.876a.375.375,0,0,1,.375-.375', 'M10.125,5.251a.374.374,0,0,1-.375-.375', 'M10.5,4.876a.374.374,0,0,1-.375.375', 'M10.125,9.751a.375.375,0,0,1,.375.375', 'M9.75,10.126a.375.375,0,0,1,.375-.375', 'M10.125,10.5a.374.374,0,0,1-.375-.375', 'M10.5,10.126a.374.374,0,0,1-.375.375', 'M4.5 3.001L5.25 3.751 6 0.751 10.5 0.751']]
};
exports["default"] = _default;